function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function claim_confirmation() {
  return import(
    /* webpackChunkName: "page-claim-confirmation" */ '@/pages/claim-confirmation.vue'
  )
}
function join_confirmation() {
  return import(
    /* webpackChunkName: "page-join-confirmation" */ '@/pages/join-confirmation.vue'
  )
}
function lock() {
  return import(/* webpackChunkName: "page-lock" */ '@/pages/lock.vue')
}
function login() {
  return import(/* webpackChunkName: "page-login" */ '@/pages/login.vue')
}
function payments() {
  return import(/* webpackChunkName: "page-payments" */ '@/pages/payments.vue')
}
function pending() {
  return import(/* webpackChunkName: "page-pending" */ '@/pages/pending.vue')
}
function pricing() {
  return import(/* webpackChunkName: "page-pricing" */ '@/pages/pricing.vue')
}
function signup() {
  return import(/* webpackChunkName: "page-signup" */ '@/pages/signup.vue')
}
function sso() {
  return import(/* webpackChunkName: "page-sso" */ '@/pages/sso.vue')
}
function userSettings() {
  return import(
    /* webpackChunkName: "page-userSettings" */ '@/pages/userSettings.vue'
  )
}
function app_store_index() {
  return import(
    /* webpackChunkName: "page-app-store-index" */ '@/pages/app-store/index.vue'
  )
}
function clients_index() {
  return import(
    /* webpackChunkName: "page-clients-index" */ '@/pages/clients/index.vue'
  )
}
function employees_index() {
  return import(
    /* webpackChunkName: "page-employees-index" */ '@/pages/employees/index.vue'
  )
}
function onboarding_index() {
  return import(
    /* webpackChunkName: "page-onboarding-index" */ '@/pages/onboarding/index.vue'
  )
}
function payables_index() {
  return import(
    /* webpackChunkName: "page-payables-index" */ '@/pages/payables/index.vue'
  )
}
function proposals_index() {
  return import(
    /* webpackChunkName: "page-proposals-index" */ '@/pages/proposals/index.vue'
  )
}
function purchase_orders_index() {
  return import(
    /* webpackChunkName: "page-purchase-orders-index" */ '@/pages/purchase-orders/index.vue'
  )
}
function receivables_index() {
  return import(
    /* webpackChunkName: "page-receivables-index" */ '@/pages/receivables/index.vue'
  )
}
function trips_index() {
  return import(
    /* webpackChunkName: "page-trips-index" */ '@/pages/trips/index.vue'
  )
}
function vendors_index() {
  return import(
    /* webpackChunkName: "page-vendors-index" */ '@/pages/vendors/index.vue'
  )
}
function work_orders_index() {
  return import(
    /* webpackChunkName: "page-work-orders-index" */ '@/pages/work-orders/index.vue'
  )
}
function approval_pending() {
  return import(
    /* webpackChunkName: "page-approval-pending" */ '@/pages/approval/pending.vue'
  )
}
function company_edit() {
  return import(
    /* webpackChunkName: "page-company-edit" */ '@/pages/company/edit.vue'
  )
}
function company_dashboard_index() {
  return import(
    /* webpackChunkName: "page-company-dashboard-index" */ '@/pages/company/dashboard/index.vue'
  )
}
function company_profile_new() {
  return import(
    /* webpackChunkName: "page-company-profile-new" */ '@/pages/company/profile/new.vue'
  )
}
function app_store__app_index() {
  return import(
    /* webpackChunkName: "page-app-store-app-index" */ '@/pages/app-store/_app/index.vue'
  )
}
function clients__id() {
  return import(
    /* webpackChunkName: "page-clients-id" */ '@/pages/clients/_id.vue'
  )
}
function employees__id() {
  return import(
    /* webpackChunkName: "page-employees-id" */ '@/pages/employees/_id.vue'
  )
}
function payables__id() {
  return import(
    /* webpackChunkName: "page-payables-id" */ '@/pages/payables/_id.vue'
  )
}
function proposals__id() {
  return import(
    /* webpackChunkName: "page-proposals-id" */ '@/pages/proposals/_id.vue'
  )
}
function purchase_orders__id() {
  return import(
    /* webpackChunkName: "page-purchase-orders-id" */ '@/pages/purchase-orders/_id.vue'
  )
}
function receivables__id() {
  return import(
    /* webpackChunkName: "page-receivables-id" */ '@/pages/receivables/_id.vue'
  )
}
function trips__id() {
  return import(/* webpackChunkName: "page-trips-id" */ '@/pages/trips/_id.vue')
}
function vendors__id() {
  return import(
    /* webpackChunkName: "page-vendors-id" */ '@/pages/vendors/_id.vue'
  )
}
function work_orders__id_index() {
  return import(
    /* webpackChunkName: "page-work-orders-id-index" */ '@/pages/work-orders/_id/index.vue'
  )
}
function work_orders__id_edit() {
  return import(
    /* webpackChunkName: "page-work-orders-id-edit" */ '@/pages/work-orders/_id/edit.vue'
  )
}
function work_orders__id_trips_index() {
  return import(
    /* webpackChunkName: "page-work-orders-id-trips-index" */ '@/pages/work-orders/_id/trips/index.vue'
  )
}
function work_orders__id_trips__tripid_index() {
  return import(
    /* webpackChunkName: "page-work-orders-id-trips-tripid-index" */ '@/pages/work-orders/_id/trips/_tripid/index.vue'
  )
}
function _name_index() {
  return import(
    /* webpackChunkName: "page-name-index" */ '@/pages/_name/index.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
    meta: {
      requiresAuth: false,
      requiresCompany: false,
      disabled: false,
    },
  },
  {
    name: 'claim-confirmation',
    path: 'claim-confirmation',
    component: claim_confirmation,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      disabled: false,
    },
  },
  {
    name: 'join-confirmation',
    path: 'join-confirmation',
    component: join_confirmation,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      disabled: false,
    },
  },
  {
    name: 'lock',
    path: 'lock',
    component: lock,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      disabled: false,
    },
  },
  {
    name: 'login',
    path: 'login',
    component: login,
    meta: {
      requiresAuth: false,
      requiresCompany: true,
      disabled: false,
      requiresDefaultDomain: true,
    },
  },
  {
    name: 'payments',
    path: 'payments',
    component: payments,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'pending',
    path: 'pending',
    component: pending,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'pricing',
    path: 'pricing',
    component: pricing,
    meta: {
      title: 'Pricing',
      requiresAuth: false,
      requiresCompany: false,
      requiresDefaultDomain: true,
      disabled: false,
    },
  },
  {
    name: 'signup',
    path: 'signup',
    component: signup,
    meta: {
      requiresAuth: false,
      requiresCompany: false,
      requiresDefaultDomain: true,
      disabled: false,
    },
  },
  {
    name: 'sso',
    path: 'sso',
    component: sso,
    meta: {
      requiresAuth: false,
      requiresCompany: true,
      disabled: false,
      requiresDefaultDomain: true,
    },
  },
  {
    name: 'userSettings',
    path: 'userSettings',
    component: userSettings,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'app-store',
    path: 'app-store',
    component: app_store_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'clients',
    path: 'clients',
    component: clients_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'employees',
    path: 'employees',
    component: employees_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'onboarding',
    path: 'onboarding',
    component: onboarding_index,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      disabled: false,
    },
  },
  {
    name: 'payables',
    path: 'payables',
    component: payables_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'proposals',
    path: 'proposals',
    component: proposals_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'purchase-orders',
    path: 'purchase-orders',
    component: purchase_orders_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'receivables',
    path: 'receivables',
    component: receivables_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'trips',
    path: 'trips',
    component: trips_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'vendors',
    path: 'vendors',
    component: vendors_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'work-orders',
    path: 'work-orders',
    component: work_orders_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'approval-pending',
    path: 'approval/pending',
    component: approval_pending,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'company-edit',
    path: 'company/edit',
    component: company_edit,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      disabled: false,
      requiresDefaultDomain: false,
    },
  },
  {
    name: 'company-dashboard',
    path: 'company/dashboard',
    component: company_dashboard_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
    },
  },
  {
    name: 'company-profile-new',
    path: 'company/profile/new',
    component: company_profile_new,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'app-store-app',
    path: 'app-store/:app',
    component: app_store__app_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'clients-id',
    path: 'clients/:id?',
    component: clients__id,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'employees-id',
    path: 'employees/:id?',
    component: employees__id,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'payables-id',
    path: 'payables/:id?',
    component: payables__id,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'proposals-id',
    path: 'proposals/:id?',
    component: proposals__id,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'purchase-orders-id',
    path: 'purchase-orders/:id?',
    component: purchase_orders__id,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'receivables-id',
    path: 'receivables/:id?',
    component: receivables__id,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'trips-id',
    path: 'trips/:id?',
    component: trips__id,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'vendors-id',
    path: 'vendors/:id?',
    component: vendors__id,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'work-orders-id',
    path: 'work-orders/:id',
    component: work_orders__id_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'work-orders-id-edit',
    path: 'work-orders/:id/edit',
    component: work_orders__id_edit,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'work-orders-id-trips',
    path: 'work-orders/:id/trips',
    component: work_orders__id_trips_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
    redirect: { path: 'work-orders/:id' },
  },
  {
    name: 'work-orders-id-trips-tripid',
    path: 'work-orders/:id/trips/:tripid',
    component: work_orders__id_trips__tripid_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
  {
    name: 'name',
    path: ':name',
    component: _name_index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      disabled: false,
    },
  },
]
